export default {"src":"/_next/static/media/icon-instagram.63f8eae7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};